import { render, staticRenderFns } from "./ModalRenombrarDocumento.vue?vue&type=template&id=0c5bb243&scoped=true&"
import script from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bb243",
  null
  
)

export default component.exports